const DefaultImages = {
  project:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPc8x8AAn0BvalaEbQAAAAASUVORK5CYII=',
  client:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPc8x8AAn0BvalaEbQAAAAASUVORK5CYII=',
};

export default DefaultImages;
